import { UserQueryDocument } from "@pathwright/graphql-client/src/generated"

export default UserQueryDocument
